import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import * as Layout from '../../common/styles/Layout';
import { classNames } from '../../common/styles/Utils';
import { EmptyStateStyle, EmptyStateSubTitleStyle, EmptyStateTitleStyle } from '../styles/SearchResultPageStyles';

export const NoResultPageTestID = 'NoResultPageTestID';

export function NoResultPage(): JSX.Element {
  return (
    <div aria-live="polite" role="status" className={classNames(EmptyStateStyle, Layout.absolute, Layout.center)}>
      <div className={EmptyStateTitleStyle} data-tb-test-id={NoResultPageTestID}>
        {Messages.NoResultsHeader()}
      </div>
      <div className={EmptyStateSubTitleStyle}>{Messages.NoResultsMessage()}</div>
    </div>
  );
}
